import React, { Component } from "react";
import Dialog from "../dialog";
import DialogInput from "../input";
import DialogInputBox from "../inputbox";
//import TimeCodeInput from "../timecodeinput";
import TimeCodeInput from "../../appcode/appcomponents/appmediaassets/submenudialogs/timecodeinput/timecodeinput";

import { V2_ConvertTimeCodeStringToSecond, V2_recfps } from "../../../utils/timecodev2";
import { V2_ConvertSecondToTimeCodeString } from "../../../utils/timecodev2";

import { ApiPostSetTimeCodeVideo, apiReadOneVideo } from "../../../utils/apis";
class OffsetVideo extends Dialog
{
  constructor(props) 
  {
    super(props);

    const title = {
        fr:"Définir l'offset de la vidéo", 
        en:"Set Video Offset",
      };
    this.state.title = title;
    this.state.tobecenter = true;

    this.state.buttons = 
    [
      //{type:"text", disabled:true,text:{fr:"Accepter",en:"Accept"},key:"accept"},
      {type:"back", disabled:false},
      {type:"ok", disabled:false},
      
    ]

    this.state.formulaire = 
      {
        viid: this.props.viid,
        filename: "",
        timecode: "00:00:00:00",
        duration: "00:00:00:00",
        fps:25,
        dropframe: 0,
        num:25,
        den:1,
        enabledropframe: false,
        apply: false,

      }
   

    this.handleButton =  this.handleButton.bind(this);

    this.videoReadCallBack = this.videoReadCallBack.bind(this);
    this.onOffsetWrote = this.onOffsetWrote.bind(this);;

      
      this.filenameRef = React.createRef();

      this.durationRef = React.createRef();
      this.framerateRef = React.createRef();
      this.timecodeRef = React.createRef();
      this.dropframeRef = React.createRef();
      this.applyRef = React.createRef();
      

      this.onQuit = this.onQuit.bind(this)
      this.onValid = this.onValid.bind(this)
      this.handleOnChange = this.handleOnChange.bind(this)
      this.didMount = false;

   
    
  }


  componentDidMount()
  {

    // lecture de la vidéo

    this.didMount=true;
    super.componentDidMount();

    apiReadOneVideo ({viid: this.props.viid}, this.videoReadCallBack)
  }

  videoReadCallBack(datas)
  {
    if (!Array.isArray(datas)) 
      this.onQuit();
    else
    {
        // on a retrouvé la 7eme compagnie
        if (datas.length ===0)
          this.onQuit();
        else
        {
            var video = datas[0];

            var formulaire = this.state.formulaire;

            formulaire.filename = video.viorifile;

            console.log("video = ", video)

            formulaire.timecode = video.vitimecode;


            console.log("video time code ", video.vitimecode)
            // ici on prend en compte le décalage du player

            if (this.props.videotime !== 0)
            {
                formulaire.timecode =
                  V2_ConvertSecondToTimeCodeString(
                    V2_ConvertTimeCodeStringToSecond(
                            video.vitimecode,
                            video.vinum,
                            video.viden,
                            video.vidropframe?1:0,
                            video.vitimecode
                          ) + this.props.videotime,
                            video.vinum,
                            video.viden,
                            video.vidropframe?1:0,
                            video.vitimecode
                    )
            }


            console.log("props ", this.props.videotime,"time code", formulaire.timecode)

            formulaire.duration = video.viduration;
            formulaire.num = video.vinum;
            formulaire.den = video.viden;

            var framerate = video.viframerate.toFixed(2).replace('.', ','); // "1234,56"
            framerate = framerate + " (" + video.vinum+"/"+video.viden+")";

              if (video.vidropframe === 1)
                framerate = framerate + " DF";
              else
                framerate = framerate + " NDF";

            formulaire.framerate = framerate;

            const ffps = V2_recfps(video.vinum, video.viden);
            
            switch (ffps)
            {
              case 25:
                formulaire.enabledropframe=false;
                formulaire.dropframe=false;
                formulaire.fps = 25; break;
              case 24:
              case 23.98:
                formulaire.enabledropframe=false;
                formulaire.dropframe=false;
                formulaire.fps = 24; break;
              case 30:
                formulaire.enabledropframe=false;
                formulaire.dropframe=false;
                formulaire.fps = 30; break;
              case 29.97:
                formulaire.enabledropframe=true;
                formulaire.dropframe=video.vidropframe;
                formulaire.fps = 30; break;
            
            }

            this.filenameRef.current.setValue(formulaire.filename)
            this.framerateRef.current.setValue(formulaire.framerate)
            //this.timecodeRef.current.setValue(formulaire.timecode);
            this.durationRef.current.setValue(formulaire.duration)
            this.dropframeRef.current.setValue(formulaire.dropframe)

            console.log("formulaire", formulaire)
            this.setState({formulaire:formulaire})

            
      
            


            
        }


    }
  }

  onValid(datas)
  {
  }

  onQuit()
  {
    this.props.onButton("back", this.state.formulaire);    
  }

  handleOnChange()
  {
      if (!this.timecodeRef) return;
      if (!this.timecodeRef.current) return;
      
      const newtc = this.timecodeRef.current.getValue();
      if (newtc.error)
        return; // not possible

      const timecode = newtc.timecode;
      const dropframe = this.dropframeRef.current.getValue();
      
      const newtime = V2_ConvertTimeCodeStringToSecond(
        timecode,
        this.state.formulaire.num,
        this.state.formulaire.den,
        dropframe?1:0
      )

      

      
      const tcoffset =  V2_ConvertSecondToTimeCodeString(newtime - this.props.videotime,
          this.state.formulaire.num,this.state.formulaire.den,dropframe?1:0);


      this.state.formulaire.timecode = timecode;
      this.state.formulaire.dropframe = dropframe;
      this.state.formulaire.reeloffset = tcoffset;
      
      
  }

  onOffsetWrote()
  {
    
    var retour = this.state.formulaire;
    retour.dropframe = this.dropframeRef.current.getValue()?1:0;
    if (this.props.mode !== "none")
      retour.apply = this.applyRef.current.getValue();
    else
      retour.apply = false;
    this.props.onButton("ok", retour);
  }

  handleButton(buttonkey)
  {
    
    if (buttonkey === "ok")
    {
        const newtc = this.timecodeRef.current.getValue();
        if (newtc.error) return;

        const timecode = newtc.timecode;
        const dropframe = this.dropframeRef.current.getValue()?1:0;


        const newtime = V2_ConvertTimeCodeStringToSecond(
          timecode,
          this.state.formulaire.num,
          this.state.formulaire.den,
          dropframe?1:0
        )

      if (newtime - this.props.videotime < 0) return; // not possible

      const tcoffset =  V2_ConvertSecondToTimeCodeString(newtime - this.props.videotime,
          this.state.formulaire.num,this.state.formulaire.den,dropframe?1:0);

        
        // on ecrit tout ça
        const datas = {viid: this.props.viid, 
          timecode: tcoffset, 
          dropframe: this.dropframeRef.current.getValue()?1:0};
        this.state.formulaire.reeloffset = tcoffset;
        ApiPostSetTimeCodeVideo(datas, this.onOffsetWrote);
        
        return;


    }

    this.props.onButton(buttonkey, this.state.formulaire);
  }

  render()
  {


    var mode = (<></>);
    if (this.props.mode === "apply")
    {
      mode = (
        <>
        <br/>
      <DialogInputBox
                value = {this.state.formulaire.apply}
                disabled={false}
                autoFocus = {true}
                onChange =  {this.handleOnChange}
                ref = {this.applyRef}
                title = {this.context.language=="fr"?"Appliquer aux assets":"Apply to assets"}
              />

        </>
      )
    }

    const div1 =
    (
      <div >
        <div style={{padding:"10px", align:"center"}}>
            {this.context.language=="fr"?"Saisissez le time code que vous voyez dans l'image.":"Enter timecode displayed into the player."}
        </div>
        <br/>
        <div style = {{width:"80%", marginLeft:"10%", height:"48px", backgroundColor:"#303030"}} >
          <TimeCodeInput
                  initialValue = {this.state.formulaire.timecode}
                  maxFrames = {this.state.formulaire.fps-1}
                  ref = {this.timecodeRef}
                  autoFocus = {true}
                />
        </div>
        <br/>
      
      <DialogInputBox
                value = {this.state.formulaire.dropframe}
                disabled={!this.state.formulaire.enabledropframe}
                autoFocus = {false}
                onChange =  {this.handleOnChange}
                ref = {this.dropframeRef}
                title = {this.context.language=="fr"?"Times codes Drop Frame":"D.F. times codes"}
              />

        {mode}

        <br/>


      <DialogInput
                value = {this.state.formulaire.filename}
                disabled={false}
                autoFocus = {false}
                ref = {this.filenameRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "250px"
                align="center"
                title = {this.context.language=="fr"?"Fichier original":"Original file"}
              />
        <br/>


      <DialogInput
                value = {this.state.formulaire.duration}
                disabled={false}
                autoFocus = {false}
                ref = {this.durationRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "120px"
                align="center"
                title = {this.context.language=="fr"?"Durée":"Duration"}
              />
      <DialogInput
                value = {this.state.formulaire.framerate}
                disabled={false}
                autoFocus = {false}
                ref = {this.framerateRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "190px"
                align="center"
                title = {this.context.language=="fr"?"Frame Rate":"Frame Rate"}
              />



      </div>
    )


    return super.render(
  
    <>
      <div style = {{width:280, height: 340}}>
              {div1}
      </div>
     </>
    );
  }


}
OffsetVideo.defaultProps = 
{ 
    mode: "none",
}


export default OffsetVideo;